// Import orchestrators - they self-register when imported
import './onModuleClickPstTasksOrchestrator';
import './onSelectFolderResetPstTasksOrchestrator';

/**
 * Initialize PST Tasks orchestrators
 * This function ensures the orchestrators are registered
 * and should be called during mail module initialization
 */
export function initializePstTasksOrchestrators(): void {
    // Orchestrators are already registered via the imports above
    // This function exists to provide an explicit initialization point
}
